<template>
  <transition name="fade">
    <LvText
      v-if="isShow"
      h5
      white
      class="lv-snack-bar"
    >
      {{title}}
    </LvText>
  </transition>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      isShow: false,
    }
  },
  methods: {
    $_openSnackBar() {
      this.isShow = true;
    },
    $_closeSnackBar() {
      this.isShow = false;
    },
  }
}
</script>